// constants
import * as types from './actionTypes'
// services
import contextService from '../../services/ContextService'
import mainService from '../../services/MainService'
// utils
import { query2Object } from '../../utils/URLUtils'
import { removeQuery } from '../../utils/Router'

export function requestDataByContext() {
  return {
    type: types.REQUEST_DATA_BY_CONTEXT,
    isLoading: true,
    receivedAt: null,
    error: null
  }
}

export function receiveDataByContext({ data, context, error }) {
  return {
    type: types.RECEIVE_DATA_BY_CONTEXT,
    isLoading: false,
    receivedAt: Date.now(),
    data,
    error,
    context,
  }
}

export function fetchDataByContext(callback = () => {}) {
  return async dispatch => {
    dispatch(requestDataByContext())
    const query = query2Object(window.location.search)
    const context = query.context || ''
    try {
      const data = await contextService.getData(context)
      dispatch(receiveDataByContext({ data, context }))
      callback(null, data)
    } catch (error) {
      console.error(error.message)
      dispatch(receiveDataByContext({ data: {}, error: 'Erro ao consultar informações' }))
      callback(new Error('Erro ao consultar informações'))
    }
  }
}

export function resetDataContext() {
  return {
    type: types.RESET_DATA_CONTEXT,
  }
}

/**
 * Limpa context de clinica da URL e recarrega informações.
 */
export function clearContext() {
  return async dispatch => {
    removeQuery('context')
    dispatch(fetchDataByContext())
  }
}

function requestSaveAnexo() {
  return {
    type: types.REQUEST_SAVE_ANEXO_PACIENTE,
    isLoading: true,
  }
}

function receiveSaveAnexo() {
  return {
    type: types.RECEIVE_SAVE_ANEXO_PACIENTE,
    isLoading: false,
  }
}

/**
 * Envia dados para persistência de anexo (exame) do paciente.
 */
export function fetchSaveAnexo(data, context = null, callback = () => {}) {
  return async dispatch => {
    dispatch(requestSaveAnexo())
    try {
      await contextService.postAnexo(data, context)
      dispatch(receiveSaveAnexo())
      callback()
    } catch (error) {
      console.error(error.message)
      dispatch(receiveSaveAnexo())
      callback(error)
    }
  }
}

function requestRemoveAnexo() {
  return {
    type: types.REQUEST_REMOVE_ANEXO_PACIENTE,
    isLoading: true,
  }
}

function receiveRemoveAnexo() {
  return {
    type: types.RECEIVE_REMOVE_ANEXO_PACIENTE,
    isLoading: false,
  }
}

/**
 * Remove anexo (exame) do paciente por id.
 */
export function fetchRemoveAnexo(id, context = null, callback = () => {}) {
  return async dispatch => {
    dispatch(requestRemoveAnexo())
    try {
      await contextService.deleteAnexo(id, context)
      dispatch(receiveRemoveAnexo())
      callback()
    } catch (error) {
      console.error(error.message)
      dispatch(receiveRemoveAnexo())
      callback(error)
    }
  }
}

function requestSaveDocPaciente() {
  return {
    type: types.REQUEST_SAVE_DOC_PACIENTE,
    isLoading: true,
  }
}

function receiveSaveDocPaciente() {
  return {
    type: types.RECEIVE_SAVE_DOC_PACIENTE,
    isLoading: false,
  }
}

/**
 * Envia dados para persistência de doc ou selfie de confirmação do paciente ou dependente.
 */
export function fetchSaveDocPaciente(data, callback = () => {}) {
  return async dispatch => {
    dispatch(requestSaveDocPaciente())
    try {
      await contextService.postDocPaciente(data)
      dispatch(receiveSaveDocPaciente())
      callback()
    } catch (error) {
      console.error(error.message)
      dispatch(receiveSaveDocPaciente())
      callback(error)
    }
  }
}

function requestSaveDataToNfse() {
  return {
    type: types.REQUEST_SAVE_DATA_TO_NFSE,
    isLoading: true,
  }
}

function receiveSaveDataToNfse() {
  return {
    type: types.RECEIVE_SAVE_DATA_TO_NFSE,
    isLoading: false,
  }
}

/**
 * Persiste alteração de dados para geração de NFS-e do usuário logado.
 */
export function fetchSaveDataToNfse(data, callback = () => {}) {
  return async dispatch => {
    dispatch(requestSaveDataToNfse())
    try {
      await mainService.putDataToNfse(data)
      dispatch(receiveSaveDataToNfse())
      dispatch(fetchDataByContext())
      callback()
    } catch (error) {
      console.error(error.message)
      dispatch(receiveSaveDataToNfse())
      callback(error)
    }
  }
}

function requestSavePersonalData() {
  return {
    type: types.REQUEST_SAVE_PERSONAL_DATA,
    isLoading: true,
  }
}

function receiveSavePersonalData() {
  return {
    type: types.REQUEST_SAVE_PERSONAL_DATA,
    isLoading: false,
  }
}

/**
 * Persiste alteração de dados pessoais do usuário logado.
 */
export function fetchSavePersonalData(data, callback = () => {}) {
  return async dispatch => {
    dispatch(requestSavePersonalData())
    try {
      await mainService.putPersonalData(data)
      dispatch(receiveSavePersonalData())
      dispatch(fetchDataByContext())
      callback()
    } catch (error) {
      console.error(error.message)
      dispatch(receiveSavePersonalData())
      callback(error)
    }
  }
}

